import data from "../../../../../src/Radio.docs.json";
import * as React from 'react';
export default {
  data,
  React
};